import React, { useState, useEffect, useContext } from 'react';
import {
  Table,
  Stack,
  Button,
  Typography,
  Grid,
  Backdrop,
  CircularProgress,
} from '@mui/material';
import MUIDataTable from 'mui-datatables';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import Iconify from '../../../iconify';
const { PRIVATE_ROUTE } = API_ROUTES;

export default function UserList() {
  const [open, setOpen] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(null);
  const { authAxios } = useContext(FetchContext);
  const [sortEnable, setSortEnable] = useState({});
  const [searchEnable, setSearchEnable] = useState();

  const navigate = useNavigate();
  const getUserdata = (query) => {
    let sort_params;
    let page_cout = query.page_no ? query.page_no : 0;
    if (typeof query !== 'string') {
      sort_params = `&sortField=${query.sortField}&sortOrder=${query.sortOrder}&search=${
        query.searchQuery ? query.searchQuery : ''
      }`;
    } else {
      sort_params = `&search=${query}`;
    }
    let isMounted = true;
    const getUsers = async () => {
    
       const { data } = await authAxios.get(
        `${PRIVATE_ROUTE?.GET_USER}?page=${page_cout + 1}&per_page=${rowsPerPage}${sort_params}`
      );
      if (isMounted) {
        setUsers(
          data?.data?.map((item) => {
            return {
              _id: item._id,
              first_name: item.first_name,
              last_name: item.last_name,
              email: item.email,
              role: item.role,
              remark: item.remark,
            };
          })
        );
        setCount(data.total);
        setLoading(false);
      }
    };
    getUsers().catch((err) => {
      if (!isMounted) return;
      console.error('failed to fetch data', err);
    });
    return () => {
      isMounted = false;
    };
  };
  const columns = [
    {
      name: '_id',
      label: '_id',
      options: {
        draggable: false,
        sort:false,
        filter: false,
        display: false,
      },
    },
    {
      name: 'first_name',
      label: 'First Name',
      options: {
        draggable: true,
        sort: true,
        filter: true,
        display: true,
      },
    },
    {
      name: 'last_name',
      label: 'Last Name',
      options: {
        draggable: true,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'email',
      label: 'Email',
      options: {
        draggable: true,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'role',
      label: 'Role',
      options: {
        draggable: true,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'remark',
      label: 'Remarks',
      options: {
        draggable: true,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: '',
      lable: 'Action',
      options: {
        filter: true,
        sort:false,
        display: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', gap: '5px' }}>
            <EditIcon onClick={(e) => handleEditRedirect(e, tableMeta.rowData[0])} />
            <DeleteIcon onClick={(e) => handleRowDelete(e, tableMeta.rowData[0])} />
          </div>
          );
        },
      },
    },
  ];
  const options = {
    selectToolbarPlacement: 'none',
    tableId: 'HelloWorld',
    rowHover: false,
    jumpToPage: true,
    responsive: 'standerd',
    print: true,
    filter: false,
    fixedHeader: true,
    count: count,
    searchOpen: true,
    selectableRows: false,
    setRowProps: (row, dataIndex, rowIndex) => {
      return {
        style: {
          backgroundColor: rowIndex % 2 === 0 ? 'rgba(101, 200, 208,0.15)' : 'white',
        },
      };
    },
    setTableProps: () => {
      return {
        padding: 'default',
        border: '1px solid #65C8D0',
        size: 'small',
      };
    },
  
    onSearchChange: (searchQuery) => {
      if (searchQuery !== null && searchQuery.length > 2) {
        setSearchEnable(searchQuery);
        if (Object.keys(sortEnable).length !== 0) {
          const sortField = sortEnable.name; 
          const sortOrder = sortEnable.direction; 
          getUserdata({ sortField, sortOrder, searchQuery }); 
        } else {
          getUserdata(searchQuery);
        }
        setLoading(true);
      }
      if (searchQuery === null) {
        if (Object.keys(sortEnable).length !== 0) {
          const sortField = sortEnable.name; 
          const sortOrder = sortEnable.direction; 
          getUserdata({ sortField, sortOrder }); 
        } else {
          getUserdata('');
        }
      }
    },
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
    },
    rowsPerPage: rowsPerPage,
    serverSide: true,
   
     onTableChange: (action, tableState) => {
      const { name, direction } = tableState.sortOrder;
      const sortField = name; 
      const sortOrder = direction; 
      let searchQuery = searchEnable;
      let page_no = tableState.page;
      if (action === 'sort') {
        setSortEnable(tableState.sortOrder);
        if (searchEnable) {
          getUserdata({ sortField, sortOrder, searchQuery, page_no }); 
        } else {
          getUserdata({ sortField, sortOrder, page_no }); 
        }
      }
      if (action === 'changePage') {
        setPage(tableState.page);
        if (searchEnable) {
          getUserdata({ sortField, sortOrder, searchQuery, page_no }); 
        } else {
          getUserdata({ sortField, sortOrder, page_no }); 
        }
      }
    },
  };
  const handlejobcreateform = () => {
    navigate('/user/create');
  };
  const handleEditRedirect = (e,id) => {
    navigate(`/user/update/${id}`);
  };
  const handleRowDelete = async (e,id) => {
    if (confirm('Are you sure want to delete?') === true) {
      setLoading(false);
      await authAxios.post(`${PRIVATE_ROUTE?.DELETE_USER}${id}`);
      setOpen(null);
      setSelectedRow(null);
      setLoading(true);
      getUserdata('');
    }
  };

  useEffect(() => {
    getUserdata('');
  }, [rowsPerPage]);

  return (
    <>
      <Grid sx={{ p: 4, pb: 0 }} direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h4" gutterBottom>
            User
          </Typography>
          <Button variant="contained" onClick={handlejobcreateform} startIcon={<Iconify icon="eva:plus-fill" />}>
            New User
          </Button>
        </Stack>
        <Table>
          <MUIDataTable options={options} columns={columns} data={users} />
        
          {loading && (
            <div>
              <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                <CircularProgress color="inherit" />
              </Backdrop>
            </div>
          )}
        </Table>
      </Grid>
    </>
  );
}
